import styled from 'styled-components';

const Wrap = styled.div`
    padding: 80px 0;
    text-align: center;
`;

const Text = styled.strong`
    font-weight: 700;
    font-size: 18px;
    line-height: 23px;
`;

const P = styled.p`
    margin-top: 17px;
    color: var(--dark-gray);
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
`;

export { Wrap, Text, P };
